<script lang="ts" setup>
import type { StatusColor } from '~/types'

const model = defineModel<boolean | any[]>()

withDefaults(
  defineProps<{
    inputValue?: string | number | boolean | null
    isDisableUserSelect?: boolean
    isOrderTag?: boolean
    isStatus?: boolean
    labelText?: string | null
    name: string
    orderTagColor?: string | null
    statusColor?: StatusColor | null
  }>(),
  {
    inputValue: null,
    isDisableUserSelect: false,
    isOrderTag: false,
    isStatus: false,
    labelText: null,
    orderTagColor: null,
    statusColor: null
  }
)

const emit = defineEmits<{
  (e: 'onCheckboxChanged', event: any): void
}>()
</script>

<template>
  <label
    class="flex cursor-pointer items-center text-base leading-5"
    :class="{ 'select-none': isDisableUserSelect }"
  >
    <input
      v-model="model"
      class="
        relative mr-3 size-4 shrink-0 cursor-pointer appearance-none rounded border border-solid border-main-silver
        bg-white outline-none after:absolute after:left-[5px] after:top-[3px] after:hidden after:h-[7px]
        after:w-1 after:rotate-45 after:border-b-2 after:border-r-2 after:border-white after:content-['']
        checked:border-main-green checked:bg-main-green checked:after:block
      "
      :name="name"
      type="checkbox"
      :value="inputValue"
      @change="emit('onCheckboxChanged', $event)"
    >

    <Status v-if="isStatus && statusColor" :color="statusColor" :title="labelText" />
    <OrderTag v-else-if="isOrderTag && orderTagColor" :color="orderTagColor" :title="labelText" />
    <span v-else-if="labelText" class="simple" v-html="labelText" />
  </label>
</template>
